<template>
    <div>
        <ToolsBox></ToolsBox>
        <I18nHelper></I18nHelper>
    </div>
</template>
<script>
import I18nHelper from './I18nHelper'
import ToolsBox from './ToolsBox'
export default {
    components: {
        I18nHelper,
        ToolsBox,
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Main.vue